var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.21967 0.71967C-0.0732232 1.01256 -0.0732231 1.48744 0.21967 1.78033L2.54792 4.10858C2.62602 4.18668 2.62602 4.31332 2.54792 4.39142L0.219671 6.71967C-0.0732219 7.01256 -0.0732218 7.48744 0.219672 7.78033C0.512565 8.07322 0.987439 8.07322 1.28033 7.78033L4.10355 4.95711C4.49408 4.56658 4.49408 3.93342 4.10355 3.54289L1.28033 0.71967C0.987437 0.426776 0.512563 0.426777 0.21967 0.71967Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.3ca733fe88aff16360bb7b4ce89bd93a.svg";
export { ForwardRef as ReactComponent };